<template>
    <div class="contentWrap joinsect">
        <div class="peopleNum">
            <p>已有 <span>{{peopleNum}}</span>位兄弟再次集结 </p>
            <span>5月20日新服【渡劫封仙】爆燃开启</span>
         
        </div>
        <div class="modal" v-if="dialogFormVisible">
            <div class="sect_modal">
                <span @click="closeModal()"></span>
                <input maxlength="7" placeholder="请输入宗门名称" v-model="listQuery.familyName" type="text" class="sect_input sect_name">
                <select placeholder="请选择宗门特色" v-model="listQuery.familyFeature" class="sect_input sect_characteristic" name="" id="">
                    <option value="">请选择宗门特色</option>
                    <option value="金牌指挥坐镇">金牌指挥坐镇</option>
                    <option value="兄弟有点难必帮">兄弟有点难必帮</option>
                    <option value="只动手不动口">只动手不动口</option>
                    <option value="无限原地复活">无限原地复活</option>
                    <option value="活跃度每天100">活跃度每天100%</option>
                    <option value="好战分子扎堆">好战分子扎堆</option> 
                    <option value="打架仙药管够">打架仙药管够</option>
                </select>
                <textarea placeholder="请输入宗门名言" v-model="listQuery.familyNotice" class="sect_textarea" name="" id="" cols="30" rows="10"></textarea>
                <input placeholder="请输入宗主微信号" v-model="listQuery.weixin" type="text" class="sect_input sect_wx">
                <input placeholder="请输入宗主手机号" v-model="listQuery.tel" type="text" class="sect_input sect_phone">
                 <!-- {{listQuery.weixinImg}} -->
                <div class="uploadImgBox">
                     
                      <el-upload
                      v-if="listQuery.weixinImg  == ''"
                    class="upload-demo"
                    :action="addPropsAction"
                    :on-preview="handlePreview"
                    :on-success="handleAvatarSuccess"
                    multiple
                    :limit="1"
                    :file-list="fileList">
                        <div class="up_qrcode">
                            <img src="../assets/text.png" alt="">
                        </div>
                    </el-upload>
                  
                    <img v-else :src="service_url+listQuery.weixinImg" alt="">
                </div>
                  
                <div class="sect_btn">
                     <img @mouseout="hoverOver(1,'submit_btn.png')" @mouseover="hoverOver(1,'submithigh_btn.png')" @click="CreateFamilyFn()" :src="saveBtn" alt="">
                      <img @mouseout="hoverOver(2,'back_icon.png')" @mouseover="hoverOver(2,'backhigh_icon.png')" class="backBtn" @click="closeModal()" :src="backBtn" alt="">
                </div>
            </div>
        </div>
        <bindRole @closeBindRole="closeBindRole" v-if="bindState"></bindRole>
       <!-- <div class="diaLog">

       </div> -->
    </div>
</template>
<script>
import bindRole from '@/components/bindRole'
import { GetTotalUserCount , CreateFamily ,GetBindRoleInfo} from '@/untils/authority'
export default {
    name:'index',
    components:{
        bindRole
    },
    data(){
        return {
            dialogFormVisible:true,
            form:{
               name:'' ,
               region:''
            },
              service_url: process.env.VUE_APP_upload_URL
        ? process.env.VUE_APP_upload_URL
        : "",
            listQuery:{
                familyName:'',
                familyFeature:'',
                familyNotice:'',
                weixinImg:'',
                tel:'',
                weixin:'',
            },
            saveBtn:require('@/assets/submit_btn.png'),
            backBtn:require('@/assets/back_icon.png'),
            fileList:[],
            peopleNum:0,
            bindState:false,
            input:''
        }
    },
    created(){
this.addPropsAction = this.service_url+'/api/file/uploadfile'
    },
    mounted(){
        if(document.body.offsetWidth<1920){
            document.getElementsByClassName('sect_modal')[0].style.transform = 'scale(.9)'
        }
       
        this.GetTotalUserCountFn()
        this.GetBindRoleInfoFn()
    },
    methods:{
        // 获取用户数量
        GetTotalUserCountFn(){
            GetTotalUserCount().then(response => {
                if(response.result == 1){
                    this.peopleNum = response.data
                }else{

                }
            })
        },
        handlePreview(file){
            console.log(file)
        },
        handleAvatarSuccess(row){
            if(row.result == 1){
                 this.listQuery.weixinImg = row.data
                 console.log(row)
                 console.log(row.data)
                 console.log(this.listQuery.weixinImg)
            }
        
        },
        hoverOver(type,url){
            if(type== 1){
                this.saveBtn = require('@/assets/'+url)
            }else{
                this.backBtn = require('@/assets/'+url)
            }
        },
        // 关闭绑定
        closeBindRole(data){
            this.bindState = false
            console.log(data)
             this.$store.commit('SET_ROLENAME', data.roleName)
        },
        // 创建宗门
        CreateFamilyFn(){
            CreateFamily(this.listQuery).then(response => {
                if(response.result == 1){
                    alert('加入成功')
                           this.$emit('slideTo',{})
                }else{
                    alert(response.message)
                    // if(response.result == 7){
                    //     this.bindState = true
                    // }
                }
            })
        },
        // 是否绑定角色
        GetBindRoleInfoFn(){
            GetBindRoleInfo().then(response => {
                if(response.result == 1){
                    this.$store.commit('SET_ROLENAME', response.data.roleName)
                }else if(response.result == 0){
                    alert('未登录，请先登录联众账号')
                    location.href = `http://passport.ourgame.com/lzgamelogin!webhallb.do?from=video&nexturl=`+location.href
                }else{
                    this.bindState = true
                }
            })
        },
        closeModal(){
          this.dialogFormVisible = false
        }
    }
}
</script>
<style lang="less">
.contentWrap{
     background:url('../assets/bg.jpg');
     width:100%;
     background-position: center;
     height:100vh;
}

.modal{
    position: fixed;
    // top:0px;
    width:100vw;
    height:100vh;
    // left:0px;
    background:rgba(0,0,0,0.6);
    .sect_modal{
        width: 1106px;
        height: 800px;
        position: absolute;
        top:-40px;
        left:0px;
        right:0px;
        bottom:0px;
        margin:auto;
        background:url(../assets/sect_bg.png)
    }
}
.sect_input{
    width: 213px;
	height: 30px;
    text-indent: 6px;;
    border: solid 1px #874a26;
    
}
.sect_name{
margin-left: 266px;
 margin-top: 220px;
}
.sect_wx{
margin-left: 284px;
    margin-top: 30px;
 	width: 144px;
	height: 29px;
	border: solid 1px #874a26;
}
.sect_phone{
    width: 160px;
	height: 29px;
	border: solid 1px #874a26;
    margin-left: 150px;
    margin-top: 30px;
}
.sect_textarea{
    margin-left: 153px;
    margin-top: 71px;
 width: 803px;
 padding:12px;
 box-sizing: border-box;
	height: 119px;
	border: solid 1px #874a26;
}
.sect_characteristic{
margin-left: 263px;
 margin-top: 220px;
}
.uploadImgBox{
   margin-right:165px;
      margin-top:20px;
       	width: 138px;
     
	height: 138px;
    text-align:center;
    >img{
        width: 138px;
        margin-left:801px;
	height: 138px;
    }
}
.up_qrcode{
    // float:right;
    // margin-left:800px;
 
    
    // float:right;
    	width: 138px;
     
	height: 138px;
	border: solid 1px #874a26;
    color:white;
    text-align:center;
    >img{
        padding-top:16px;
    }
}
.upload-demo{
    // float:right;
    position: relative;
    left:800px;
}
.sect_modal>span{
     float:right;
     width: 60px;
	height: 77px;
    margin-top:80px;
}
.sect_btn{
    width:440px;
    margin:0px auto;
    margin-top:2px;
    >img+img{
        margin-left:182px
    }
}
.joinsect{
    position: relative;
    .peopleNum{
        // padding-top:61%;
        // float:right;
        // padding-right:20%;
        position: absolute;
    //   osition: fixed;
    bottom: 19vh;
    left: 50vw;
        >p{
           color: #ffffff; 
           	font-size: 37px;
               width: 598px;
	height: 71px;
    background:url('../assets/desire_bg.png');
    text-align: center;
            span{
                color: #e6a417;
                font-size: 53px;
              
            }
        }
        >span{
              width: 598px;
                display: block;
                text-align: center;
            display: block;
            padding-top:20px;
            color: #282950;
            	font-size: 34px;
        }
    }
}
.el-upload-list__item-name{
    display: none!important;
}
</style>